import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_120_add_parts_issue: any[] = [
  {
    "componentType": "screenGroup",
    "title": "Parts issue",
    "style": {},
    "childComponents": [
      {
        "componentType": "form",
        "Name": "parts_issue",
        "TableName": "service_spare_part_issue",
        "Plugins": [
          {
            "type": "api"
          }
        ],
        "columnNumber": "m1 t1 w1",
        "style": {
          "padding": 10,
          "backgroundColor": "#ffffff",
          "direction": "column"
        },
        "Fields": [
          {
            "componentType": "fieldGroup",
            "Label": "Parts issue details",
            "BindValue": "con_parts_issue_details",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "componentType": "textField",
                "name": "spare_issue_no",
                "label": "SIN#",
                "placeholder": "Will be auto generated...",
                "required": false,
                "inputType": "text",
                "Json_Attribute": "spare_issue_no",
                "BindValue": "spare_issue_no",
                "disabled": true,
                "AutoPopulate": true,
                "AutoPopulate_format": "SPI_[******]"
              },
              {
                "componentType": "dateField",
                "name": "issue_date",
                "label": "Issue date",
                "required": true,
                "Json_Attribute": "issue_date",
                "BindValue": "issue_date",
                "DefaultToday": true,
                "validation": [
                  {
                    "rule": "required",
                    "message": "Issue date is required"
                  }
                ]
              },
              {
                "componentType": "searchableDropdown",
                "name": "parentid",
                "label": "Jobcard no",
                "placeholder": "",
                "required": true,
                "lookupName": "parts_issue_jobcard",
                "options": [],
                "searchable": true,
                "BindValue": "parentid",
                "clearable": true,
                "Json_Attribute": "parent_id",
                "validation": [
                  {
                    "rule": "required",
                    "message": "Jobcard no is required"
                  }
                ]
              },
              {
                "componentType": "textField",
                "name": "txt_customername",
                "label": "Customer name",
                "required": false,
                "inputType": "text",
                "BindValue": "txt_customername",
                "Json_Attribute": "job_card_customername",
                "disabled": true,
                "BindParent": {
                  "parentid": "customername"
                }
              },
              {
                "componentType": "textField",
                "name": "txt_reg_no",
                "label": "Reg No.",
                "required": false,
                "inputType": "text",
                "BindValue": "txt_reg_no",
                "Json_Attribute": "job_card_reg_no",
                "disabled": true,
                "BindParent": {
                  "parentid": "reg_no"
                }
              }
            ]
          },
          {
            "componentType": "subModule",
            "name": "service_spare_parts_issue",
            "label": "Part details",
            "TableName": "service_spare_parts_issue_details",
            "lookupName": "Parts_request_Spareparts",
            "BindValue": "service_spare_parts_issue",
            "parentField": "parentid",
            "childControls": [
              {
                "componentType": "textField",
                "name": "est_ref_id",
                "label": "",
                "placeholder": "",
                "required": false,
                "inputType": "text",
                "Json_Attribute": "est_ref_id",
                "disabled": true,
                "IsHidden": true,
                "BindValue": "est_ref_id",
                "style": {
                  "display": "none"
                }
              },
              {
                "componentType": "textField",
                "name": "txt_rate",
                "label": "Rate",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "defaultValue": "0",
                "Json_Attribute": "rate",
                "disabled": true,
                "BindValue": "txt_rate"
              },
              {
                "componentType": "textField",
                "name": "txt_item_name_free",
                "label": "Item Name",
                "placeholder": "Enter Item Name",
                "required": true,
                "inputType": "text",
                "Json_Attribute": "item_name_free",
                "BindValue": "txt_item_name_free"
              },
              {
                "componentType": "searchableDropdown",
                "name": "drp_code",
                "label": "Code",
                "placeholder": "",
                "required": false,
                "IsMandatory": true,
                "lookupName": "product_itemcode",
                "options": [],
                "searchable": true,
                "clearable": true,
                "Json_Attribute": "codeid",
                "BindValue": "drp_code"
              },
              {
                "componentType": "textField",
                "name": "txt_qty",
                "label": "Requested qty.",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "defaultValue": "0",
                "Json_Attribute": "qty",
                "BindValue": "txt_qty",
                "disabled": true,
                "validation": [
                  {
                    "rule": "condition",
                    "condition": "[qty] >= [issued_qty]",
                    "message": "Issue quantity should be less or equal to requested quantity"
                  }
                ]
              },
              {
                "componentType": "textField",
                "name": "txt_stock_qty",
                "label": "Stock qty.",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "BindValue": "txt_stock_qty",
                "defaultValue": "0",
                "ExpressionV2": "[drp_code.stock_qty]",
                "Json_Attribute": "stock_qty",
                "disabled": true,
                "validation": [
                  {
                    "rule": "condition",
                    "condition": "[stock_qty] > 0",
                    "message": "Some requested parts are out of stock. There are pending items to be issued. Kindly purchase the required items",
                    "isWarning": true
                  }
                ]
              },
              {
                "componentType": "textField",
                "name": "txt_issued_qty",
                "label": "Issue qty.",
                "placeholder": "",
                "required": false,
                "BindValue": "txt_issued_qty",
                "inputType": "number",
                "defaultValue": "0",
                "Json_Attribute": "issued_qty",
                "validation": [
                  {
                    "rule": "pattern",
                    "value": "^[0-9]*$",
                    "message": "Only numbers are allowed"
                  },
                  {
                    "rule": "condition",
                    "condition": "[issued_qty] <= [stock_qty]",
                    "message": "Issued quantity should not be greater than stock quantity",
                    "isWarning": true
                  }
                ]
              },
              {
                "componentType": "batchAllocation",
                "name": "batch_allocation",
                "label": "Batch Allocation",
                "lookupName": "product_batch_stock",
                "parentField": "drp_code",
                "issueQtyField": "txt_issued_qty",
                "BindValue": "batch_allocation",
                "Json_Attribute": "batch_allocation"
              },
              {
                "componentType": "textField",
                "name": "txt_balance_qty",
                "label": "Balance qty.",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "defaultValue": "0",
                "BindValue": "txt_balance_qty",
                "Json_Attribute": "bal_qty",
                "disabled": true,
                "ExpressionV2": "[txt_qty] - [txt_issued_qty]"
              },
              {
                "componentType": "textField",
                "name": "txt_amount",
                "label": "Amount",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "defaultValue": "0",
                "Json_Attribute": "amount",
                "BindValue": "txt_amount",
                "disabled": true,
                "ForceExpressionUpdate": true,
                "ExpressionV2": "[txt_rate] * [txt_issued_qty]"
              },
              {
                "componentType": "selectDropdown",
                "name": "drp_vat",
                "label": "VAT%",
                "placeholder": "",
                "required": false,
                "lookupName": "tax_rates",
                "BindValue": "drp_vat",
                "options": [],
                "Json_Attribute": "vat_id"
              },
              {
                "componentType": "textField",
                "name": "txt_vat_amt",
                "label": "Vat amt.",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "defaultValue": "0",
                "Json_Attribute": "vat_amt",
                "BindValue": "txt_vat_amt",
                "disabled": true,
                "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)"
              },
              {
                "componentType": "textField",
                "name": "txt_net_amt",
                "label": "Net amount",
                "placeholder": "",
                "required": false,
                "inputType": "number",
                "defaultValue": "0",
                "Json_Attribute": "net_amt",
                "BindValue": "txt_net_amt",
                "disabled": true,
                "ExpressionV2": "[txt_amount] + [txt_vat_amt]"
              }
            ]
          }
        ]
      },
      {
        "componentType": "button",
        "name": "Issue",
        "onPressAction": "save",
        "Navigate": "103"
      }
    ]
  }
];
